(() => {
  const init = (root) => {
    if (!root || root.dataset.maisonFounderV2Ready === 'true') return;
    root.dataset.maisonFounderV2Ready = 'true';

    const progress = root.querySelector('[data-maison-founder-v2-progress]');
    const update = () => {
      if (!progress) return;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? window.scrollY / max : 0;
      progress.style.transform = `scaleX(${Math.min(1, Math.max(0, ratio))})`;
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-maison-founder-v2]').forEach(init);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
